export const customFetch = <T>(
  url: string,
  options: Parameters<typeof $fetch>[1] = {},
): Promise<T> => {
  const runtimeConfig = useRuntimeConfig();

  const props: Parameters<typeof $fetch>[1] = {
    baseURL: import.meta.server
      ? runtimeConfig.API_SERVER_URL
      : runtimeConfig.public.API_SERVER_URL,
    onRequest({ options }) {
      if (useCookie('csrftoken').value) {
        options.headers.set('X-CSRFToken', `${useCookie('csrftoken').value}`);
        if (import.meta.server) {
          const cookie = useRequestHeader('cookie');
          if (cookie) {
            options.headers.set('cookie', cookie);
          }
        }
      }
    },
    ...options,
  };

  return $fetch(url, props);
};
